<template>
  <!-- toast -->
  <AlertMsg :msg="msgObj.msg" :show="msgObj.show" :role="msgObj.role" @closePopup="msgObj.show = false"></AlertMsg>
  <!-- end toast -->
  <div class="row">
    <div class="col-12">
      <div class="d-flex align-items-center mt-2">
        <h5 class="mb-0 text-primary"><i class="fas fa-users text-primary"></i> UserList</h5>
      </div>
      <hr />
      <div class="row g-3">
        <div class="col-md-3">
          <label class="form-label">Name<sup><span class="text-danger font-12">*</span></sup>
            :</label>
          <input type="text" class="form-control form-control-sm" v-model="Obj.name" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Email<sup><span class="text-danger font-12">*</span></sup>
            :</label>
           <input type="text" class="form-control form-control-sm" v-model="Obj.email" />
           <span v-if="errors.Email" class="text-danger font-12">{{ errors.Email }}</span>
        </div>
        <div class="col-md-3">
          <label class="form-label">Password<sup><span class="text-danger font-12">*</span></sup> :</label>
          <div class="input-group input-group-sm">
              <input :type="showPassword ? 'text' : 'password'" class="form-control form-control-sm" id="inputPassword" v-model="Obj.password" />
            <span class="input-group-text cursor-pointer bg-white" role="button" @click="togglePassword">
      <i :class="['fa', showPassword ? 'fa-eye' : 'fa-eye-slash' ]"></i>
         </span></div>
        </div>
        <div class="col-md-3">
          <label class="form-label">Mobile No. :</label>
          <input type="number" class="form-control form-control-sm" @input="limitDigits($event, 10, v => Obj.phone = v)" v-model="Obj.phone" />
        </div>
        <div class="col-md-12 text-end mt-1">
          <button class="btn btn-sm btn-darknavy me-1" @click="save()">
            <i class="fa fa-save"></i> Save
          </button>
          <button type="button" class="btn btn-sm btn-soft-dark" @click="reset()"><i class="fa fa-times-circle  me-1"></i> Cancel</button>
        </div>
      </div>
       <ul v-if="errors.length" class="text-danger ps-3">
          <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
        </ul>
      <div class="row">
        <div class="col-md-12 table-responsive mt-2">
           <div class="progress mb-0 progress-sm" v-if="progress!=0">
        <div class="progress-bar" role="progressbar" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"
          :style="{ width: progress + '%' }"></div>
      </div>
          <DataTable  v-if="progress==0" :columns="cols" :rows="rows" :pageSize="10"   :actions="{  edit: handleEdit, delete: handleDelete }" />
        </div>
      </div>
    </div>
  </div>
  <DelPopup :name="delObj.name" @delRecord="delRecord" @closeModal="delObj.name = ''"></DelPopup>
</template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import DelPopup from "@/components/Common/DelPopup.vue";
import DataTable from "@/components/Common/DataTable.vue";
import { isRequired, validateForm, isEmail } from '@/utils/validation.js';
import { curdStatus, api } from '@/utils/helpers.js';
import { ref, onMounted} from 'vue'
  const  Obj = ref( { name: "", email: "", password: "", phone:"", })
    const   msgObj= ref({ msg: "", role: "", show: false, })
    const   delObj = ref({})
    const   errors= ref({})
    const EditMode = ref(false);
     const showPassword = ref(false)
const cols=ref([
  { label: 'S.No', key: 'Sno' },
  { label: 'Name', key: 'name' },
  { label: 'Email', key: 'email' },
  { label: 'Mobile No', key: 'phone' },
]);
const handleEdit = (row) => {
    Obj.value = { ...row, password: '', }
    EditMode.value = true;
}
const handleDelete = (row) => {
  delObj.value = { ...row };
}
const rows=ref([])
const  togglePassword= ()=> {
  showPassword.value = !showPassword.value
    }
    const limitDigits = (event, max, assignFn) => {
  let val = event.target.value.toString().slice(0, max);
  assignFn(val.replace(/\D/g, ''));
}
const save = async() => {
      const fields = {
        Name: { value: Obj.value.name, validators: [isRequired], },
        Email: { value: Obj.value.email, validators: [isRequired, isEmail] },
      };
       if (!EditMode.value) {
    fields.Password = { value: Obj.value.password, validators: [isRequired] };
  }
      errors.value = validateForm(fields);
      if (Object.keys(errors.value).length === 0) {
        const { url, method, msg } = curdStatus(Obj.value);
        await api[method](`/users${url}`, Obj.value)
          .then((response) => {
            reset();
            msgObj.value = { msg: `UserList ${msg} Successfuly`, role: "success", show: true, };
            loadData();
            console.log(response);
          })
          .catch((error) => { console.log(error); });
      }
    }
    const reset= async() => {
      Obj.value = { name: "", email: "", password: "", phone:"", };
      msgObj.value = { msg: "", role: "", show: false, };
      errors.value = {};
      EditMode.value = false;
    }
     const progress = ref(0)
    const loadData = async() => {
          let direction = 1
     let progressInterval = setInterval(() => {
       progress.value += direction
       if (progress.value >= 100) {
         progress.value = 0 
       }
     }, 100)
      await api.get('/users/all') .then((response) => { rows.value = response.data.map((item, i) => ({ ...item, Sno: i + 1 }));
      progress.value = 0
          clearInterval(progressInterval)
    });
    }
    const delRecord= async() => {
      await api.delete(`/users/${delObj.value._id}`)
        .then(() => {
          delObj.value={};
          loadData();
          msgObj.value = { msg: "UserList Deleted Successfuly.", role: "danger", show: true, };
        });
    }
     onMounted(() => { loadData() })
</script>